var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-crud-list',_vm._b({on:{"save":_vm.save},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var id = ref.id;
var on = ref.on;
return [_c('group-form',_vm._g({ref:"form",attrs:{"id":id}},on))]}}])},'simple-crud-list',_vm.options,false))}
var staticRenderFns = []

export { render, staticRenderFns }